export function startQuantumEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.quantum-canvas[data-kind="quantum-canvas"]');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const resize = () => {
    const w = imgPanelEl.offsetWidth || 0;
    const h = imgPanelEl.offsetHeight || 0;
    canvas.width = Math.max(1, w);
    canvas.height = Math.max(1, h);
  };

  resize();

  const particles = [];
  for (let i = 0; i < 34; i++) {
    particles.push({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 2,
      vy: (Math.random() - 0.5) * 2,
      r: Math.random() * 2 + 1
    });
  }

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  let rafId = 0;
  let lastTs = 0;

  const draw = (ts) => {
    rafId = requestAnimationFrame(draw);
    if (!lastTs) lastTs = ts;
    const dt = ts - lastTs;
    if (dt < 33) return; // ~30fps cap
    lastTs = ts;

    const w = canvas.width;
    const h = canvas.height;
    if (w <= 1 || h <= 1) return;

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(255,255,0,0.4)';
    ctx.strokeStyle = 'rgba(255,255,0,0.18)';

    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;

      if (p.x < 0 || p.x > w) p.vx *= -1;
      if (p.y < 0 || p.y > h) p.vy *= -1;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();

      for (let j = i + 1; j < particles.length; j++) {
        const q = particles[j];
        const dx = p.x - q.x;
        const dy = p.y - q.y;
        const d2 = dx * dx + dy * dy;
        if (d2 < 120 * 120) {
          ctx.globalAlpha = 1 - Math.sqrt(d2) / 120;
          ctx.beginPath();
          ctx.moveTo(p.x, p.y);
          ctx.lineTo(q.x, q.y);
          ctx.stroke();
          ctx.globalAlpha = 1;
        }
      }
    }
  };

  rafId = requestAnimationFrame(draw);
  window.addEventListener('resize', resize);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (observer) observer.disconnect();
    window.removeEventListener('resize', resize);
  };
}
